import { useEffect, useState } from 'react';

import {
  SubMenuItemWrapper,
  SubMenuItemHeader,
  SubMenuItemTitle,
  SubMenuItemRibbon,
  ArrowLeft,
  ArrowDown,
  ArrowWrapper,
} from './styles';

const SubMenuItem = ({ title, component, collapsed, isCollapsible = true, onToggleCollapse }) => {
  const [isOpen, setIsOpen] = useState(collapsed);

  const toggleComponent = () => {
    if (!isCollapsible) {
      return;
    }

    if (typeof onToggleCollapse === 'function') {
      onToggleCollapse(!isOpen);
    }

    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (typeof onToggleCollapse === 'function') {
      onToggleCollapse(collapsed);
    }
  }, [isCollapsible]);

  useEffect(() => {
    const shouldReactToCollapseProp = isCollapsible && typeof collapsed === 'boolean';

    if (shouldReactToCollapseProp) {
      setIsOpen(!collapsed);
    }
  }, [collapsed, isCollapsible]);

  return (
    <SubMenuItemWrapper>
      <SubMenuItemHeader onClick={toggleComponent}>
        <SubMenuItemRibbon />

        <SubMenuItemTitle>{title}</SubMenuItemTitle>

        {isCollapsible && <ArrowWrapper>{isOpen ? <ArrowDown /> : <ArrowLeft />}</ArrowWrapper>}
      </SubMenuItemHeader>
      {isOpen && isCollapsible ? component : null}
    </SubMenuItemWrapper>
  );
};

export default SubMenuItem;
